import React, { useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';

import ApiService from '../apiservice';
import FreshChatComp from './freshchatcomp';
import * as Constants from "./../../helpers/constants"

const FreshChat = (props) => {
  const [restoreId, setRestoreId] = useState(null);
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (!props.userDetails.isLoginSuccess && props.history.action === 'PUSH' && props.history.location.pathname != '/login') {
      setKey(prevKey => prevKey + 1);
      setTimeout(() => {
        window.fcWidget && window.fcWidget.init({
          token: FRESHCHAT_TOKEN,
          widgetUuid: FRESHCHAT_WIDGET_ID,
          host: 'https://wchat.freshchat.com',
          locale: "en",
          config: Constants.FRESHCHAT_CONFIG
        })
      }, 500);
    }
  }, [props.userDetails.isLoginSuccess, props.history.action, props.history]);

  const setFcRestoreId = useCallback((restoreId) => {
    if (restoreId) {
      const body = {
        fresh_chat: {
          restore_id: restoreId
        }
      };
      ApiService.updateFreshchatRestoreId(body)
        .then(() => {
          setRestoreId(restoreId);
        })
        .catch((err) => {
          console.error('Update restore id', err);
        });
    }
  }, []);

  return (
    <FreshChatComp
      key={key}
      id={key}
      userDetails={props.userDetails}
      restoreId={restoreId}
      setFcRestoreId={setFcRestoreId}
      closeAnnounceKitWidget={props.closeAnnounceKitWidget}
    />
  );
};

const mapStateToProps = (state) => ({
  userDetails: state.userReducer
});

export default connect(mapStateToProps)(FreshChat);